import { render, staticRenderFns } from "./BaseTooltipWithIcon.vue?vue&type=template&id=6b72a804&"
import script from "./BaseTooltipWithIcon.vue?vue&type=script&lang=js&"
export * from "./BaseTooltipWithIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b72a804')) {
      api.createRecord('6b72a804', component.options)
    } else {
      api.reload('6b72a804', component.options)
    }
    module.hot.accept("./BaseTooltipWithIcon.vue?vue&type=template&id=6b72a804&", function () {
      api.rerender('6b72a804', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseTooltipWithIcon.vue"
export default component.exports